document.addEventListener('DOMContentLoaded', () => {

    const modal = document.querySelector('.morkes-search-modal');

    if (!modal) return;

    const close = modal.querySelector('.morkes-search-close');
    const overlay = modal.querySelector('.morkes-search-overlay');

    document.querySelectorAll('.morkes-search-trigger').forEach(trigger => {

        trigger.addEventListener('click', () => {
            modal.classList.add('open');
        });

    });

    function closeModal() {
        modal.classList.remove('open');
    }

    close?.addEventListener('click', closeModal);
    overlay?.addEventListener('click', closeModal);

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            closeModal();
        }
    });

});

document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('morkes-quick-shop');

    if (!modal) return;

    const closeButtons = modal.querySelectorAll('[data-morkes-close]');





    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-morkes-quick-shop]');

        if (!trigger) return;

        event.preventDefault();

        openModal(trigger.dataset.productUrl);
    });

    closeButtons.forEach(button => {
        button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !modal.hidden) {
            closeModal();
        }
    });
});

async function openModal(productUrl) {

    const modal = document.getElementById('morkes-quick-shop');
    const content = document.getElementById('morkes-quick-shop-content');
    const detailsLink = modal.querySelector('[data-morkes-product-details]');

    if (detailsLink) {
        detailsLink.href = productUrl;
    }

    content.innerHTML = '<p>Loading...</p>';

    modal.hidden = false;

    document.body.style.overflow = 'hidden';

    try {

        const response = await fetch(productUrl + '?view=morkes-quick-shop');

        const html = await response.text();

        content.innerHTML = html;

        initializeProductForm(content);

        initializeQuantityControls(

            content.querySelector('.morkes-product-form')
        );

    } catch (error) {

        content.innerHTML = '<p>Unable to load product.</p>';

        console.error(error);

    }

}

function closeModal() {
    const modal = document.getElementById('morkes-quick-shop');

    if (!modal) return;

    modal.hidden = true;
    document.body.style.overflow = '';
}

function initializeProductForm(container) {

    const productDataEl = container.querySelector('.morkes-product-data');
    const form = container.querySelector('[data-morkes-product-form]');

    if (!productDataEl || !form) return;

    const product = JSON.parse(productDataEl.textContent);

    const selects = form.querySelectorAll('.morkes-product-form__select');
    const variantInput = form.querySelector('[data-variant-id]');
    const buttonGroups = form.querySelectorAll('[data-option-buttons]');
    const submitButton = form.querySelector('button[type="submit"]');

    const initialVariant = product.variants.find(
        variant => String(variant.id) === variantInput.value
    ) || product.variants[0];

    form.morkes = {
        product,
        currentVariant: initialVariant,
        isAdding: false
    };

    function updateAddToCartButton() {

        const variant = form.morkes.currentVariant;
        const available = Boolean(variant?.available);
        const isAdding = form.morkes.isAdding;

        submitButton.disabled = !available || isAdding;

        submitButton.textContent = isAdding
            ? 'Adding...'
            : available ? 'Add to Cart' : 'Sold Out';

        // Notify the sticky Add to Cart component.
        form.dispatchEvent(new CustomEvent('morkes:availability-change', {
            detail: {
                available,
                isAdding
            }
        }));
    }

    // Make this accessible to the submit handler.
    form.morkes.updateAddToCartButton = updateAddToCartButton;

    function updateVariant() {

        const selectedOptions = [...selects].map(select => select.value);

        const variant = product.variants.find(v =>
            v.options.every((option, index) => option === selectedOptions[index])
        );

        if (!variant) {
            form.morkes.currentVariant = null;
            updateAddToCartButton();
            return;
        }

        form.morkes.currentVariant = variant;
        variantInput.value = variant.id;

        updateProductPrice(container, variant);
        updateOptionAvailability();
        updateAddToCartButton();

    }

    function updateOptionAvailability() {

        const selectedOptions = [...selects].map(select => select.value);

        buttonGroups.forEach((group, optionIndex) => {

            const buttons = group.querySelectorAll(
                '.morkes-product-form__option-button'
            );

            buttons.forEach(button => {

                const testOptions = [...selectedOptions];
                testOptions[optionIndex] = button.dataset.optionValue;

                const variantExists = product.variants.some(variant => {

                    if (!variant.available) return false;

                    return variant.options.every((option, index) =>
                        option === testOptions[index]
                    );

                });

                button.classList.toggle('is-disabled', !variantExists);

            });

        });

    }

    selects.forEach((select, index) => {

        select.addEventListener('change', () => {

            const buttons = buttonGroups[index]?.querySelectorAll(
                '.morkes-product-form__option-button'
            );

            buttons?.forEach(button => {
                button.classList.toggle(
                    'is-active',
                    button.dataset.optionValue === select.value
                );
            });

            updateVariant();

        });

    });

    buttonGroups.forEach((group, index) => {

        const buttons = group.querySelectorAll(
            '.morkes-product-form__option-button'
        );

        buttons.forEach(button => {

            button.addEventListener('click', () => {

                buttons.forEach(btn => btn.classList.remove('is-active'));

                button.classList.add('is-active');

                const select = selects[index];
                select.value = button.dataset.optionValue;

                select.dispatchEvent(new Event('change', {
                    bubbles: true
                }));

            });

        });

    });

    // Single-variant products have no option selectors.
    if (selects.length === 0) {

        updateProductPrice(container, initialVariant);
        updateAddToCartButton();

    } else {

        updateVariant();

    }

}

function formatMoney(cents) {

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(cents / 100);

}

function updateProductPrice(container, variant) {

    const quantityInput =
        container.querySelector('.morkes-product-form__quantity-input');

    const quantity = Number(quantityInput?.value || 1);

    const total = variant.price * quantity;

    const price = container.querySelector('[data-product-price]');
    const comparePrice = container.querySelector('[data-product-compare-price]');

    if (price) {
        price.textContent = formatMoney(total);
    }

    if (comparePrice) {

        if (variant.compare_at_price > variant.price) {

            comparePrice.textContent =
                formatMoney(variant.compare_at_price * quantity);

            comparePrice.style.display = '';

        } else {

            comparePrice.style.display = 'none';

        }

    }

}

function initializeQuantityControls(form) {

    if (!form) return;

    const container =
        form.closest('.morkes-product') ||
        form.closest('#morkes-quick-shop-content');

    const quantityInput = form.querySelector('.morkes-product-form__quantity-input');

    const minusButton = form.querySelector('[data-quantity-minus]');

    const plusButton = form.querySelector('[data-quantity-plus]');

    quantityInput?.addEventListener('input', () => {

        if (Number(quantityInput.value) < 1) {
            quantityInput.value = 1;
        }

        updateProductPrice(
            container,
            form.morkes.currentVariant
        );

    });

    minusButton?.addEventListener('click', () => {

        quantityInput.stepDown();

        if (quantityInput.value < 1) {
            quantityInput.value = 1;
        }

        updateProductPrice(
            container,
            form.morkes.currentVariant
        );

    });

    plusButton?.addEventListener('click', () => {

        quantityInput.stepUp();

        updateProductPrice(
            container,
            form.morkes.currentVariant
        );

    });

    fform.addEventListener('submit', async (event) => {

        event.preventDefault();

        const state = form.morkes;
        const variant = state?.currentVariant;

        if (!variant?.available || state.isAdding) return;

        const submitButton = form.querySelector('button[type="submit"]');
        const message = form.querySelector('.morkes-product-form__message');

        state.isAdding = true;
        state.updateAddToCartButton();

        message.textContent = '';
        message.classList.remove('is-visible');

        let addedSuccessfully = false;

        try {

            const formData = new FormData(form);

            const response = await fetch(
                (window.Shopify?.routes?.root || '/') + 'cart/add.js',
                {
                    method: 'POST',
                    body: formData
                }
            );

            const result = await response.json();

            if (!response.ok) {
                throw new Error(
                    result.description ||
                    result.message ||
                    'Unable to add product to cart.'
                );
            }

            addedSuccessfully = true;

            // Build the confirmation without inserting untrusted HTML.
            const confirmation = document.createElement('span');
            confirmation.textContent =
                `✓ ${result.product_title || 'Product'} added to your cart. `;

            const cartLink = document.createElement('a');
            cartLink.href = '/cart';
            cartLink.textContent = 'View Cart';

            message.replaceChildren(confirmation, cartLink);
            message.classList.add('is-visible');

            submitButton.textContent = 'Added ✓';

        } catch (error) {

            message.textContent =
                error.message || 'Unable to add product to cart.';

            message.classList.add('is-visible');

        } finally {

            // Recheck availability after the cart request.
            // This also handles the last available item being purchased.
            try {

                const productUrl =
                    (window.Shopify?.routes?.root || '/') +
                    'products/' +
                    encodeURIComponent(state.product.handle) +
                    '.js';

                const response = await fetch(productUrl, {
                    cache: 'no-store'
                });

                if (response.ok) {

                    const latestProduct = await response.json();

                    latestProduct.variants.forEach(latestVariant => {

                        const existingVariant = state.product.variants.find(
                            v => String(v.id) === String(latestVariant.id)
                        );

                        if (existingVariant) {
                            existingVariant.available = latestVariant.available;
                        }

                    });

                }

            } catch (error) {
                console.warn('Unable to refresh product availability.', error);
            }

            state.isAdding = false;
            state.updateAddToCartButton();

            // Keep the success confirmation visible in the message area.
            // The button itself returns to its current availability state.
        }

    });

}

function initializeCarousel(carousel) {

    console.log('Initializing carousel', carousel);

    const track = carousel.querySelector('[data-carousel-track]');
    const slides = [...track.children];

    const prevButton = carousel.querySelector('[data-carousel-prev]');
    const nextButton = carousel.querySelector('[data-carousel-next]');

    const dotsContainer =
        carousel.querySelector('[data-carousel-dots]');

    if (!track || slides.length === 0) return;

    let currentIndex = 0;

    let startX = 0;

    let endX = 0;

    track.addEventListener('touchstart', (event) => {

        startX = event.touches[0].clientX;

    });

    track.addEventListener('touchend', (event) => {

        endX = event.changedTouches[0].clientX;

        const difference = startX - endX;

        if (Math.abs(difference) < 40) return;

        const maxIndex = Math.max(
            0,
            slides.length - getSlidesPerView()
        );

        if (difference > 0 && currentIndex < maxIndex) {

            currentIndex++;

        }

        if (difference < 0 && currentIndex > 0) {

            currentIndex--;

        }

        update();

    });

    function buildDots() {

        if (!dotsContainer) return;

        dotsContainer.innerHTML = '';

        slides.forEach((slide, index) => {

            const dot = document.createElement('button');

            dot.type = 'button';

            dot.className = 'morkes-carousel__dot';

            dot.addEventListener('click', () => {

                currentIndex = index;

                update();

            });

            dotsContainer.append(dot);

        });

    }

    function getSlidesPerView() {

        return Math.round(track.offsetWidth / slides[0].offsetWidth);

    }

    function update() {

        const slideWidth = slides[0].offsetWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);

        track.style.transform =
            `translateX(-${currentIndex * (slideWidth + gap)}px)`;

        const maxIndex = Math.max(0, slides.length - getSlidesPerView());

        dotsContainer
            ?.querySelectorAll('.morkes-carousel__dot')
            .forEach((dot, index) => {

                dot.classList.toggle(
                    'is-active',
                    index === currentIndex
                );

            });

        prevButton.disabled = currentIndex === 0;
        nextButton.disabled = currentIndex >= maxIndex;

    }

    nextButton.addEventListener('click', () => {

        const maxIndex = Math.max(0, slides.length - getSlidesPerView());

        if (currentIndex < maxIndex) {
            currentIndex++;
            update();
        }

    });

    prevButton.addEventListener('click', () => {

        if (currentIndex > 0) {
            currentIndex--;
            update();
        }

    });

    window.addEventListener('resize', () => {

        const maxIndex = Math.max(0, slides.length - getSlidesPerView());

        if (currentIndex > maxIndex) {
            currentIndex = maxIndex;
        }

        update();

    });

    buildDots();

    update();

}

document.addEventListener('DOMContentLoaded', () => {

    function initializeStickyAddToCart() {

        const stickyBar =
            document.querySelector('[data-sticky-atc]');

        const stickyButton =
            document.querySelector('[data-sticky-atc-button]');

        const stickyPrice =
            document.querySelector('[data-sticky-price]');

        const productSection =
            document.querySelector('.morkes-product');

        if (!stickyBar || !stickyButton || !productSection) return;

        const productForm =
            productSection.querySelector('[data-morkes-product-form]');

        if (!productForm) return;

        const normalAddToCartButton =
            productForm.querySelector('button[type="submit"]');

        if (!normalAddToCartButton) return;


        /*
         * Show/hide sticky bar based on whether
         * the normal Add to Cart button is visible.
         */

        const observer = new IntersectionObserver(
            ([entry]) => {

                stickyBar.classList.toggle(
                    'is-visible',
                    !entry.isIntersecting
                );

            },
            {
                threshold: 0
            }
        );

        observer.observe(normalAddToCartButton);


        /*
         * Keep sticky price synchronized with
         * the currently selected variant.
         */

        function updateStickyAvailability() {

            const state = productForm.morkes;
            const available = Boolean(state?.currentVariant?.available);
            const isAdding = Boolean(state?.isAdding);

            stickyButton.disabled = !available || isAdding;

            stickyButton.textContent = isAdding
                ? 'Adding...'
                : available ? 'Add to Cart' : 'Sold Out';

        }

        productForm.addEventListener(
            'morkes:availability-change',
            updateStickyAvailability
        );

        updateStickyPrice();
        updateStickyAvailability();

        /*
         * Watch for changes to variant selection
         * and quantity.
         */

        productForm.addEventListener('change', updateStickyPrice);

        productForm.addEventListener('input', updateStickyPrice);

        productForm.addEventListener('click', (event) => {

            if (
                event.target.closest('[data-quantity-minus]') ||
                event.target.closest('[data-quantity-plus]')
            ) {
                // Wait until the quantity control has updated the input.
                requestAnimationFrame(updateStickyPrice);
            }

        });

        updateStickyPrice();


        /*
         * Use the existing product form when
         * the sticky button is clicked.
         */

        stickyButton.addEventListener('click', () => {

            const state = productForm.morkes;

            if (
                state?.currentVariant?.available &&
                !state.isAdding
            ) {
                productForm.requestSubmit();
            }

        });

    }

    const productSection = document.querySelector('.morkes-product');

    if (productSection) {

        initializeProductForm(productSection);

        initializeQuantityControls(
            productSection.querySelector('.morkes-product-form')
        );

    }

    document.querySelectorAll('.morkes-carousel').forEach(initializeCarousel);

    initializeStickyAddToCart();

});

document.addEventListener('click', function (event) {

    const thumb = event.target.closest('[data-gallery-thumb]');

    if (!thumb) return;

    const gallery = thumb.closest('.morkes-product-gallery');

    if (!gallery) return;

    const image = gallery.querySelector('#morkes-product-gallery-image');

    if (!image) return;

    const newImageUrl = thumb.dataset.image;

    if (!newImageUrl) return;

    // Update active thumbnail
    gallery
        .querySelectorAll('[data-gallery-thumb]')
        .forEach(button => {
            button.classList.remove('is-active');
        });

    thumb.classList.add('is-active');

    // Change main image
    image.src = newImageUrl;

    // Keep responsive image attributes in sync
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');

    // Update alt text from the thumbnail image
    const thumbnailImage = thumb.querySelector('img');

    if (thumbnailImage?.alt) {
        image.alt = thumbnailImage.alt;
    }

});

document.addEventListener('click', function (event) {

    const button = event.target.closest('[data-tab-button]');

    if (!button) return;

    const tabs = button.closest('.morkes-product-tabs');

    const tab = button.dataset.tabButton;

    tabs.querySelectorAll('[data-tab-button]').forEach(btn => {
        btn.classList.remove('is-active');
    });

    tabs.querySelectorAll('[data-tab-panel]').forEach(panel => {
        panel.classList.remove('is-active');
    });

    button.classList.add('is-active');

    tabs
        .querySelector(`[data-tab-panel="${tab}"]`)
        .classList.add('is-active');

});

document.addEventListener('DOMContentLoaded', function () {
    const infiniteScroll = document.querySelector(
        '[data-morkes-infinite-scroll]'
    );

    if (!infiniteScroll) return;

    const productGrid = document.querySelector(
        '[data-productgrid-items]'
    );

    if (!productGrid) return;

    const pagination = infiniteScroll.querySelector(
        '.morkes-collection-grid__pagination'
    );

    if (!pagination) return;

    let loading = false;

    function getNextUrl() {
        /*
         * First try the standard rel="next" link.
         */
        let nextLink = pagination.querySelector(
            'a[rel="next"]'
        );

        /*
         * Empire may not add rel="next", so also check
         * common pagination next-link selectors.
         */
        if (!nextLink) {
            nextLink = pagination.querySelector(
                '.pagination--next a, .pagination-next a, a.pagination--next'
            );
        }

        /*
         * Finally, look through all pagination links and
         * identify the one labeled "Next".
         */
        if (!nextLink) {
            const links = pagination.querySelectorAll('a');

            for (const link of links) {
                const text = link.textContent.trim().toLowerCase();
                const ariaLabel = (
                    link.getAttribute('aria-label') || ''
                ).toLowerCase();

                if (
                    text === 'next' ||
                    text.includes('next') ||
                    ariaLabel.includes('next')
                ) {
                    nextLink = link;
                    break;
                }
            }
        }

        return nextLink ? nextLink.href : null;
    }

    async function loadNextPage() {
        if (loading) return;

        const nextUrl = getNextUrl();

        if (!nextUrl) {
            observer.disconnect();
            infiniteScroll.remove();
            return;
        }

        loading = true;
        infiniteScroll.classList.add('is-loading');

        try {
            const response = await fetch(nextUrl, {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (!response.ok) {
                throw new Error(
                    'Failed to load next collection page.'
                );
            }

            const html = await response.text();

            const parser = new DOMParser();

            const doc = parser.parseFromString(
                html,
                'text/html'
            );

            const newProductGrid = doc.querySelector(
                '[data-productgrid-items]'
            );

            if (!newProductGrid) {
                throw new Error(
                    'Could not find product grid on next page.'
                );
            }

            /*
             * Add the next page's products to the
             * existing product grid.
             */
            Array.from(newProductGrid.children).forEach(function (item) {
                productGrid.appendChild(item);
            });

            /*
             * Give the browser a moment to insert the new elements,
             * then allow Empire's image system to initialize them.
             */
            requestAnimationFrame(function () {
                window.dispatchEvent(new Event('resize'));
            });

            /*
             * Get the pagination from the newly loaded page.
             */
            const newPagination = doc.querySelector(
                '.morkes-collection-grid__pagination'
            );

            if (newPagination) {
                pagination.innerHTML = newPagination.innerHTML;
            } else {
                observer.disconnect();
                infiniteScroll.remove();
            }

        } catch (error) {
            console.error(
                'Morkes infinite scroll error:',
                error
            );
        } finally {
            loading = false;
            infiniteScroll.classList.remove('is-loading');
        }
    }

    const observer = new IntersectionObserver(
        function (entries) {
            if (entries[0].isIntersecting) {
                loadNextPage();
            }
        },
        {
            rootMargin: '600px 0px'
        }
    );

    observer.observe(infiniteScroll);
});